const getImageSize = (src = '', size = '100x100') => String(src || '')
  .replace('.jpg', `_${size}.jpg`)
  .replace('.png', `_${size}.png`)
  .replace('.gif', `_${size}.gif`);

export default getImageSize;
